import { render, staticRenderFns } from "./jotform-settings.vue?vue&type=template&id=a8dab2ce&"
import script from "./jotform-settings.vue?vue&type=script&lang=js&"
export * from "./jotform-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports